import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { BKJTheme } from './BKJThemeProvider.theme.js';
import { CSSFonts, CSSReset } from './BKJThemeProvider.styled.js';
export const BKJThemeProvider = ({ theme = BKJTheme, children, }) => (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CSSReset, {}), _jsx(CSSFonts, {}), children] }));
//# sourceMappingURL=BKJThemeProvider.js.map